import styled from 'styled-components';

export const LoadingSC = styled.div`
  background: #fff;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
